export default class TextInputEvent extends Event {
	/**
	 * The static BLURRED type is dispatched when the TextInput is focused and the user tabs out or click somewhere else on the screen.
	 *
	 * Example: addEventListener(TextInputEvent.BLURRED, (event: TextInputEvent) => {});
	 */
	public static BLURRED = 'TextInputEvent.blurred';
	/**
	 * The static CHANGED type is dispatched when the TextInput text is changed by the user by typing, clipping or pasting into the TextInput.
	 *
	 * Example: addEventListener(TextInputEvent.CHANGED, (event: TextInputEvent) => {});
	 */
	public static CHANGED = 'TextInputEvent.changed';
	/**
	 * The static ENTER type is dispatched when the TextInput text is focused and the user presses and releases the Enter or Numpad Enter key.
	 *
	 * Example: addEventListener(TextInputEvent.ENTER, (event: TextInputEvent) => {});
	 */
	public static ENTER = 'TextInputEvent.enter';
	/**
	 * The static FOCUSED type is dispatched when the TextInput is focused with a Pointer click or being tabbed into.
	 *
	 * Example: addEventListener(TextInputEvent.FOCUSED, (event: TextInputEvent) => {});
	 */
	public static FOCUSED = 'TextInputEvent.focused';
	/** All event types will set the TextInput.text property to the current text content of the TextInput. */
	public text: string;
	/**
	 * The TextInputEvent will be dispatched everytime the user focuses, blurs og change the text content.
	 *
	 * @param type TextInputEvent.blurred | TextInputEvent.changed | TextInputEvent.focused
	 * @param text The current text content of the TextInput
	 */
	public constructor(type: string, text: string) {
		assertIsValidType(type);
		assertIsString(text);
		super(type, { bubbles: true });
		this.text = text;
	}
}

function assertIsString(value: unknown): asserts value is string {
	if (typeof value === 'string') {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be of type string`);
}

function assertIsValidType(value: unknown): asserts value is string {
	if (value === TextInputEvent.BLURRED || value === TextInputEvent.CHANGED || value === TextInputEvent.ENTER || value === TextInputEvent.FOCUSED) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be TextInputEvent.BLURRED, TextInputEvent.CHANGED, TextInputEvent.ENTER or TextInputEvent.FOCUSED`);
}
